module.exports = __webpack_public_path__ + "img/done_outline-24px.1346c2d8.svg";